import React from 'react';
import { ILiquidityPartner, IPayOutPartner, PartnerState, PartnerProps, TabsPartners, TabsPartnersNames, TabsPartnersWidths } from './Interface';
import PartnerServices from '../../Services/PartnerService';
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';
import { TableColumn } from 'react-data-table-component';
import CustomMaterialMenu from '../../Component/DataGrid/Plugins/CustomMaterialMenu/CustomMaterialMenu';
import DataGrid from '../../Component/DataGrid/DataGrid';
import { ShowAlert } from '../../Component/ShowAlert';
import { SyncContext, SyncContextType } from '../../Contexts/BatchSyncContext';
import UserAndPermissionService from '../../Services/UserAndPermissionService';
import moment from 'moment';
import AddLiquidityPartner from './AddLiquidityPartner';
import AddPayoutPartner from './AddPayoutPartner';
import UpdateLiquidityPartner from './EditLiquidityPartner';
import UpdatePayoutPartner from './EditPayoutPartner';
import { getTabsList, Status, Texts } from '../../Component/Reusables/Utility';
import { ITabData } from '../../Component/DataGrid/Interface';


// Main class for PromoCodes component
class Partners extends React.Component<PartnerProps, PartnerState> {
    static contextType = SyncContext;
    context!: SyncContextType;

    private _tabs = Object.values(TabsPartners) as TabsPartners[];

    constructor(props_: PartnerProps) {
        super(props_);
        let tabData: ITabData[] = getTabsList(this._tabs, TabsPartners, TabsPartnersNames, TabsPartnersWidths);
        //Initialize state
        this.state = {
            accessToken: "",
            liquidityPartnerList: [],
            payOutPartnerList: [],
            currentRowsPerPage: 10,
            currentPage: 1,
            totalRows: 100,
            searchText: "",
            filterValue: "",
            isOpenAddLiquidityPartnerDialog: false,
            isOpenAddPayoutPartnerDialog: false,
            isOpenUpdateLiquidityPartnerDialog: false,
            isOpenUpdatePayoutPartnerDialog: false,
            selectedKey: "",
            userID: "",
            partner: {
                isVisible: true,
                isVisibleLiquidityTab: true,
                isVisiblePayoutTab: true,
                isDownloadVisibleLiquidity: true,
                isDownloadVisiblePayout: true,
                isAddVisibleLiquidity: true,
                isAddVisiblePayout: true,
                isEditPartnersVisible: true,
                isActivePartnersVisible: true,
                isInActivePartnersVisible: true
            },
            paginationReset: false,
            selectedTab: TabsPartners.Liquidity,
            selectedLiquidityPartner: {} as ILiquidityPartner,
            selectedPayoutPartner: {} as IPayOutPartner,
            tabData
        }
        this.getAllLiquidityPartnerList = this.getAllLiquidityPartnerList.bind(this);
        this.getAllPayOutPartnerList = this.getAllPayOutPartnerList.bind(this);
    }
    // Table columns for DataGrid
    private tableColumns: TableColumn<ILiquidityPartner>[] = [
        {
            name: 'Liquidity Partner Name',
            selector: row => row.liquidityPartnerName,
            sortable: true,
            id: "liquidityPartnerName",
            minWidth: "150px"
        },
        {
            name: 'Status',
            selector: row => row.isActive,
            sortable: true,
            id: "isActive",
            cell: (row) => {
                const statusLabel = row.isActive === 1 ?
                    <span className='status-label active'>{Status.ACTIVE}</span> :
                    <span className="status-label blocked">{Status.INACTIVE}</span>
                return statusLabel;
            }
        },
        {
            name: 'Created Date',
            selector: row => moment(row.createdDate).format('MM-DD-YYYY hh:mm A'),//hh:mm A on Do MMMM YYYY
            sortable: true,
            id: "createdDate",
            width: "190px",
            center: true,
        },
        {
            name: 'Actions',
            cell: row => {
                const { partner } = this.state;

                const menuItems = [
                    ...(row.isActive === 0 || row.isActive === 1
                        ? [{ key: "editpartner", label: "Edit Partner" }]
                        : []),
                    ...(partner.isInActivePartnersVisible && row.isActive === 1
                        ? [{ key: "inactive", label: "In-Active" }]
                        : []),
                    ...(partner.isActivePartnersVisible && row.isActive === 0
                        ? [{ key: "active", label: "Active" }]
                        : []),
                ];

                if (menuItems.length === 0) return null;

                return (
                    <CustomMaterialMenu
                        fontSize="small"
                        multiPopoverItems={menuItems}
                        onPopoverClick={(key_: string, label_: string) => {
                            if (key_ === "inactive") {
                                this.UpdateLiquidityPartnerStatus(row, key_, 0);
                            } else if (key_ === "active") {
                                this.UpdateLiquidityPartnerStatus(row, key_, 1);
                            } else if (key_ === "editpartner") {
                                this.setState({
                                    isOpenUpdateLiquidityPartnerDialog: true,
                                    selectedLiquidityPartner: row,
                                });
                            }
                        }}
                        disabled={false}
                    />
                );
            },
            allowOverflow: true,
            button: true,
            width: '120px'
        }
    ]

    private tableColumnsPayout: TableColumn<IPayOutPartner>[] = [
        {
            name: 'Payout Partner Name',
            selector: row => row.payoutPartnerName,
            sortable: true,
            id: "payoutPartnerName",
            minWidth: "80px"
        },
        {
            name: 'Supported Country',
            selector: row => row.supportedCountries,
            sortable: true,
            id: "supportedCountries",
            minWidth: "300px"
        },
        {
            name: 'Status',
            selector: row => row.isActive,
            sortable: true,
            id: "isActive",
            center: true,
            cell: (row) => {
                const statusLabel = row.isActive === 1
                    ? <span className='status-label active'>{Status.ACTIVE}</span>
                    : <span className="status-label blocked">{Status.INACTIVE}</span>
                return statusLabel;
            },
            width: "120px",
        },
        {
            name: 'Created Date',
            selector: row => moment(row.createdDate).format('MM-DD-YYYY hh:mm A'),//hh:mm A on Do MMMM YYYY
            sortable: true,
            id: "createdDate",
            width: "190px",
            center: true,
        },
        {
            name: 'Actions',
            cell: row => {
                const { partner } = this.state;

                const menuItems = [
                    ...(row.isActive === 1 || row.isActive === 0// need to add permissions for edit promo code
                        ? [{ key: "editpartner", label: "Edit Partner" }]
                        : []),
                    ...(partner.isInActivePartnersVisible && row.isActive === 1
                        ? [{ key: "inactive", label: "In-Active" }]
                        : []),
                    ...(partner.isActivePartnersVisible && row.isActive === 0
                        ? [{ key: "active", label: "Active" }]
                        : []),
                ];

                if (menuItems.length === 0) return null;

                return (
                    <CustomMaterialMenu
                        fontSize="small"
                        multiPopoverItems={menuItems}
                        onPopoverClick={(key_: string, label_: string) => {
                            if (key_ === "inactive") {
                                this.UpdatePayOutPartnerStatus(row, key_, 0);
                            } else if (key_ === "active") {
                                this.UpdatePayOutPartnerStatus(row, key_, 1);
                            } else if (key_ === "editpartner") {  // Edit Details
                                this.setState({
                                    isOpenUpdatePayoutPartnerDialog: true,
                                    selectedPayoutPartner: row,
                                });
                            }
                        }}
                        disabled={false}
                    />
                );
            },
            allowOverflow: true,
            button: true,
            width: '120px'
        }
    ]



    async componentDidMount() {
        try {
            const accessToken_ = await loadFromLocalStorage('accessToken');
            const profile_ = await loadFromLocalStorage('profile');

            if (!accessToken_ || !profile_) {
                localStorage.clear();
                window.location.href = '/';
                return;
            }

            const accessToken = accessToken_.toString();
            const userProfile = typeof profile_ === 'string' ? JSON.parse(profile_) : profile_;

            this.setState({ accessToken }, async () => {
                try {
                    if (userProfile?.roleId) {
                        const permissionResponseRaw = await UserAndPermissionService.getPermissions(accessToken, userProfile?.roleId);
                        const permissionResponse = await permissionResponseRaw.json();

                        if (!permissionResponse?.permissions?.partner?.isVisible) {
                            console.warn("Permission denied, logging out...");
                            localStorage.clear();
                            window.location.href = '/';
                            return;
                        }

                        const permissions = permissionResponse.permissions

                        this.context.dispatch({
                            type: "SET_PERMISSION", payload: {
                                permissions
                            },
                        });

                        const partner = permissionResponse.permissions.partner

                        let selectedTab = -1;
                        let tabData = this.state.tabData;
                        for (let tab of this._tabs) {
                            if (partner[`${Texts.isVisible}${TabsPartners[tab]}Tab`] && selectedTab === -1) {
                                selectedTab = tab;
                            }
                            let isVisible = partner[`${Texts.isVisible}${TabsPartners[tab]}Tab`];
                            let isDownloadVisible = partner[`${Texts.isDownloadVisible}${TabsPartners[tab]}`];
                            tabData[tab].visible = isVisible;
                            tabData[tab].isDownloadVisible = isDownloadVisible;
                        }
                        this.setState({ partner, selectedTab, tabData }, () => {
                            this.fetchData()
                        });

                    } else {
                        this.fetchData()
                    }
                } catch (error) {
                    console.error("Error fetching permissions:", error);
                }
            });
        } catch (error) {
            console.error("Error in componentDidMount:", error);
            localStorage.clear();
            window.location.href = '/';
        }
    }

    handleTabChange = (event: React.ChangeEvent<{}>, newValue: TabsPartners) => {
        this.setState((prevState: { paginationReset: any; }) => ({
            selectedTab: newValue,
            currentPage: 1,
            paginationReset: !prevState.paginationReset,
        }), () => this.fetchData());
    };

    fetchData = () => {
        switch (this.state.selectedTab) {
            case TabsPartners.Liquidity:
                this.getAllLiquidityPartnerList();
                break;
            case TabsPartners.Payout:
                this.getAllPayOutPartnerList();
                break;
            default:
                break;
        }
    };

    getTableData = () => {
        switch (this.state.selectedTab) {
            case TabsPartners.Liquidity:
                return this.state.liquidityPartnerList;
            case TabsPartners.Payout:
                return this.state.payOutPartnerList;
            default:
                return [];
        }
    };

    getTableColumns(): TableColumn<ILiquidityPartner | IPayOutPartner>[] {
        switch (this.state.selectedTab) {
            case TabsPartners.Liquidity:
                return this.tableColumns as TableColumn<ILiquidityPartner | IPayOutPartner>[];
            case TabsPartners.Payout:
                return this.tableColumnsPayout as TableColumn<ILiquidityPartner | IPayOutPartner>[];
            default:
                return [];
        }
    }

    private onClickAddButton = () => {
        switch (this.state.selectedTab) {
            case TabsPartners.Liquidity:
                this.setState({ isOpenAddLiquidityPartnerDialog: true });
                break;
            case TabsPartners.Payout:
                this.setState({ isOpenAddPayoutPartnerDialog: true });
                break;
            default:
                console.warn("Unhandled tab selection");
                break;
        }
    };

    public isDownloadVisible(): boolean | undefined {
        return this.state.partner ? (this.state.partner as any)[`${Texts.isDownloadVisible}${TabsPartners[this.state.selectedTab]}`] : false;
    };

    public isAddVisible(): boolean | undefined {
        return this.state.partner ? (this.state.partner as any)[`${Texts.isAddVisible}${TabsPartners[this.state.selectedTab]}`] : false;
    };

    public getTabName(): string {
        return (TabsPartnersNames as any)[TabsPartners[this.state.selectedTab]];
    };


    public render() {
        const { searchText, selectedTab, totalRows, paginationReset } = this.state;
        return (
            <>
                <div className="body-sub-container table-container">
                    <DataGrid
                        title='Partners'
                        search={this.getTabName().toLowerCase()}
                        defaultSearch={searchText}
                        onSearch={(searchText_: string) => {
                            this.setState({
                                searchText: searchText_,
                                currentPage: 1
                            }, () => {
                                this.fetchData();
                            });
                        }}
                        columns={this.getTableColumns()}
                        data={this.getTableData()}
                        onChangePage={(page: number, totalRows: number) => {
                            this.setState({
                                currentPage: page
                            }, () => {
                                this.fetchData();
                            })
                        }}
                        onChangeRowsPerPage={(currentRowsPerPage_: number, currentPage_: number) => {
                            this.setState({
                                currentRowsPerPage: currentRowsPerPage_,
                                currentPage: currentPage_
                            }, () => {
                                this.fetchData();
                            })
                        }}
                        pagination
                        paginationTotalRows={totalRows}
                        exportCsv={this.isDownloadVisible()}
                        csvFileName={this.getTabName()}
                        showAddButton={this.isAddVisible()}
                        titleAddButton={`Add ${this.getTabName().toLowerCase()}`}
                        onClickAddButton={this.onClickAddButton}
                        onTabChange={this.handleTabChange}
                        selectedTab={selectedTab}
                        paginationDefaultPage={1}
                        paginationResetDefaultPage={paginationReset}
                        hasColumnSelection={false}
                        tabData={this.state.tabData}
                    />
                </div>
                {this.state.isOpenAddLiquidityPartnerDialog && (
                    <AddLiquidityPartner
                        open={this.state.isOpenAddLiquidityPartnerDialog}
                        onClose={(state: boolean, action: string) => {
                            this.setState({
                                isOpenAddLiquidityPartnerDialog: false
                            })
                        }}
                        refreshData={this.getAllLiquidityPartnerList}
                        accessToken={this.state.accessToken}
                    />
                )}
                {this.state.isOpenAddPayoutPartnerDialog && (
                    <AddPayoutPartner
                        open={this.state.isOpenAddPayoutPartnerDialog}
                        onClose={(state: boolean, action: string) => {
                            this.setState({
                                isOpenAddPayoutPartnerDialog: false
                            })
                        }}
                        refreshData={this.getAllPayOutPartnerList}
                        accessToken={this.state.accessToken}
                    />
                )}
                {this.state.isOpenUpdateLiquidityPartnerDialog && this.state.selectedLiquidityPartner && (
                    <UpdateLiquidityPartner
                        open={this.state.isOpenUpdateLiquidityPartnerDialog}
                        onClose={(state: boolean, action: string) => {
                            this.setState({
                                isOpenUpdateLiquidityPartnerDialog: false
                            })
                        }}
                        refreshData={this.getAllLiquidityPartnerList}
                        liquidityPartnerData={this.state.selectedLiquidityPartner}
                        accessToken={this.state.accessToken}
                    />
                )}
                {this.state.isOpenUpdatePayoutPartnerDialog && this.state.selectedPayoutPartner && (
                    <UpdatePayoutPartner
                        open={this.state.isOpenUpdatePayoutPartnerDialog}
                        onClose={(state: boolean, action: string) => {
                            this.setState({
                                isOpenUpdatePayoutPartnerDialog: false
                            })
                        }}
                        refreshData={this.getAllLiquidityPartnerList}
                        payoutPartnerData={this.state.selectedPayoutPartner}
                        accessToken={this.state.accessToken}
                    />
                )}
            </>
        )
    }

    // Fetch all liquidity partner..
    private async getAllLiquidityPartnerList() {
        let pageIndex: number = 1;
        let pagination: any = {
            "pageNumber": pageIndex,
            "recordPerPage": this.state.currentRowsPerPage
        }

        if (this.state.searchText) {
            pagination["searchText"] = this.state.searchText;
        }

        try {
            const tr = await PartnerServices.getAllLiquidityPartner(this.state.accessToken, pagination);

            if (tr.ok) {
                tr.json().then(resp => {
                    console.log(resp)
                    this.setState({
                        liquidityPartnerList: resp.liquidityPartnerList,
                        totalRows: resp.totalPages
                    })
                });
            } else {
                ShowAlert("Error", "Failed to fetch liquidity partners. Please try again later.", "error");
            }
        } catch (error) {
            console.error("Error fetching liquidity partners:", error);
            ShowAlert("Error", "An unexpected error occurred while fetching liquidity partners.", "error");
        }
    }

    // Fetch all payout partners...
    private async getAllPayOutPartnerList() {
        let pageIndex: number = 1;
        let pagination: any = {
            "pageNumber": pageIndex,
            "recordPerPage": this.state.currentRowsPerPage
        }

        if (this.state.searchText) {
            pagination["searchText"] = this.state.searchText;
        }

        try {
            const tr = await PartnerServices.getAllPayOutPartnerList(this.state.accessToken, pagination);

            if (tr.ok) {
                const resp = await tr.json();
                this.setState({
                    payOutPartnerList: resp.payoutPartnerList || [],
                    totalRows: resp.pageCount,
                });
            } else {
                ShowAlert("Error", "Failed to fetch payout partners. Please try again later.", "error");
            }
        } catch (error) {
            console.error("Error fetching payout partners:", error);
            ShowAlert("Error", "An unexpected error occurred while fetching payout partners.", "error");
        }
    }

    // Update the status of a liquidity partner, Active or InActive
    private async UpdateLiquidityPartnerStatus(row_: ILiquidityPartner, key_: string, status: number) {
        try {
            const liquidityPartnerId = row_.liquidityPartnerId;
            const partner = row_.liquidityPartnerName;

            const resp = await PartnerServices.UpdateLiquidityPartnerStatus(this.state.accessToken, liquidityPartnerId, status);

            if (resp?.ok) {
                await this.getAllLiquidityPartnerList();
                ShowAlert("PassportPay", `Liquidity Partner ${partner} has been ${key_}.`, "success");
            } else {
                let errorMessage = "Failed to update the Liquidity Partner status. Please try again later.";
                ShowAlert("Error", errorMessage, "error");
            }
        } catch (error) {
            console.error("Error updating liquidity partner status:", error);
            ShowAlert("Error", "An unexpected error occurred while updating the Liquidity Partner status. Please try again.", "error");
        }
    }

    // Update the status of a payout partner, Active or InActive
    private async UpdatePayOutPartnerStatus(row_: IPayOutPartner, key_: string, status: number) {
        try {
            const payoutPartnerId = row_.payoutPartnerId;
            const partner = row_.payoutPartnerName;

            const resp = await PartnerServices.UpdatePayOutPartnerStatus(this.state.accessToken, payoutPartnerId, status);

            if (resp?.ok) {
                await this.getAllPayOutPartnerList();
                ShowAlert("PassportPay", `Payout Partner ${partner} has been ${key_}.`, "success");
            } else {
                let errorMessage = "Failed to update the Payout Partner status. Please try again later.";
                ShowAlert("Error", errorMessage, "error");
            }
        } catch (error) {
            console.error("Error updating Payout partner status:", error);
            ShowAlert("Error", "An unexpected error occurred while updating the Payout Partner status. Please try again.", "error");
        }
    }

}

export default Partners;